<template>
  <La1Vue :ratio="'1fr 700px'" :style="{gap:0}">
    <TableDef slot="left" :rows="rows">
      <template slot="slot_head">
        <th :style="{textAlign:'start', width: '12em'}">區域</th>
        <th :style="{textAlign:'start', width: 'inherit'}">名稱</th>
        <th>品項數量</th>
        <th>編輯</th>
        <th>刪除</th>
        </template>
        <tr slot-scope="{item:{name, items, _id, areas}, index}" :style="{borderBottom:'none'}" @click="row=(row?._id===_id) ? null : {_id, name, areas, items, index}">
          <td :style="{textAlign:'start'}">{{areas.join(' | ')}}</td>
          <td :style="{textAlign:'start'}">{{name}}</td>
          <td>{{items.length}}</td>
        <td><EditBtn @click="$router.replace({ name: $route.name, query: { page: '編輯特製群組', id: _id } })" :style="{marginInline: 'auto'}"></EditBtn></td>
        <td><DelBtn @click="deleteItem={_id, index, name}" :style="{marginInline: 'auto'}"></DelBtn></td>
        </tr>
    </TableDef>
    <div class="rightbox">
      <div v-if="row">
        <div class="rightTitle">{{row.name}} <div>{{row.areas.join(' / ')}}</div></div>
        <div class="items">
          <div v-for="(otitem, ot) in row.items" :key="`otitem-${ot}`" class="item">
            <div>
              {{otitem.name}} </div>
            <div v-if="ot!==0">$ {{otitem.price}}</div>
            <div v-else>預設</div>
          </div>
        </div>
      </div>
    </div>
    <comfirmVue :show="!!deleteItem"  v-if="!!deleteItem" :label="'確認刪除'" :text='`確定要刪除"${deleteItem.name}"嗎?`' @confirm="deleteOne(deleteItem._id, deleteItem.index)" @cancel="deleteItem=null"/>
  </La1Vue>
</template>

<script>
import La1Vue from '../../../components/layout/La1.vue'
import TableDef from '../../../components/tables/t2.vue'
import DelBtn from '../../../components/btn/del.vue'
import EditBtn from '../../../components/btn/edit.vue'
import { getapi, deleteapi } from '../../../store/fetch'
export default {
  components: { TableDef, La1Vue, DelBtn, EditBtn },
  data () {
    return {
      rows: [],
      row: null,
      deleteItem: null
    }
  },
  async mounted () {
    await this.getGroups()
  },
  methods: {
    async getGroups () {
      this.rows = await getapi('options/pool')
    },
    async deleteOne (id, index) {
      await deleteapi(`options/pool/${id}`)
      this.rows.splice(index, 1)
      this.deleteItem = null
    }
  }

}
</script>

<style lang="scss" scoped>
.rightbox {
  border-left: 1px solid #CACACA;
  height: 100%;
  padding: 23px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.rightTitle {
  width: 600px;
  display: flex;
  align-items: center;
  height: 60px;
  font-size: 28px;
  font-weight: 700;
  color: var(--color-pri);
  div {
    background-color: var(--color-pri);
    color: #FFFFFF;
    font-size: 16px;
    min-width: 60px;
    padding-inline: 10px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    margin-left: auto;
  }
}
.items {
  width: 600px;
  padding: 10px 20px;
  border: 1px solid var(--color-pri);
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  max-height: calc(100vh - 200px);
  hr {
    width: 100%;
    margin-block: 10px;
    background-color: var(--color-pri);
    height: 1px;
    border: none;
  }
}
.item {
  font-size: 20px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
